import { query, collection, getDoc, doc } from 'firebase/firestore'
import type { StorageModuleDeps } from '~common/storage/types'

export interface Shortcut {
    id?: string
    title: string
    url: string
    lastActive: number
}

export class ProfilePicturesStorageModule {
    constructor(private deps: StorageModuleDeps) {}

    async getProfilePictureBase64(googleEmail: string): Promise<string | null> {
        const userId = this.deps.ensureAuthenticated()
        const profileRef = doc(
            this.deps.db,
            'users',
            userId,
            'profilePictures',
            googleEmail,
        )
        const snapshot = await getDoc(profileRef)
        return snapshot.data()?.imageBase64 || null
    }
}
